import { useQuery } from '@tanstack/react-query';
import { PreferenceDeleteCheck } from '../../../types/Preference';
import CustomAxios from '../../../utility/customAxios';
import { queryKeys } from '../queryKeys';

export const preferenceDeleteCheck = async (uuid: string) => {
  const response = await CustomAxios.get<PreferenceDeleteCheck[]>(`preferences/${uuid}/delete_check`);
  const { data } = response;
  return data;
};

interface UsePreferenceDeleteCheckProps {
  enabled: boolean;
  uuid: string;
}
export function usePreferenceDeleteCheck({ enabled, uuid }: UsePreferenceDeleteCheckProps) {
  const query = useQuery({
    enabled,
    retry: false,
    queryKey: [queryKeys.allPreferences, 'check', uuid],
    queryFn: () => preferenceDeleteCheck(uuid),
  });

  return query;
}
